const TESTER_HOSTS = new Set(["localhost", "127.0.0.1", "web-dev.timeghost.io"]);

export const isTesterHost = (hostname: string): boolean => TESTER_HOSTS.has(hostname);

export const isTimeghostEmail = (email: string | null | undefined): boolean =>
	(email ?? "").trim().toLowerCase().endsWith("@timeghost.io");

export const emailFromRawUser = (raw: unknown): string | undefined => {
	if (!raw || typeof raw !== "object") {
		return;
	}
	const email = (raw as { readonly email?: unknown }).email;
	return typeof email === "string" ? email : undefined;
};

export const resolveTesterHostname = (hostname?: string): string => {
	if (hostname !== undefined) {
		return hostname;
	}
	if (typeof window === "undefined") {
		return "";
	}
	return window.location.hostname;
};

export const canAccessTestingPage = (input: {
	readonly email: string | null | undefined;
	readonly hostname?: string;
}): boolean => isTesterHost(resolveTesterHostname(input.hostname)) && isTimeghostEmail(input.email);
